import { makeStyles } from "@material-ui/core";

export const FPermisoStyle = makeStyles((theme) => ({
  textField: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  textFieldMultiLinea: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  formControl: {
    width: "90%",
    margin: "5px",
  },
  containerSpacing: {
    margin: "10px 0",
  },
  modalBotones: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalBotonesCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBoton: {
    margin: "1px 0",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "900px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none",
    boxShadow: theme.shadows[10],
    padding: theme.spacing(1, 2, 1),
    minWidth: "1000px",
    maxWidth: "900px",
  },
}));
